import React, { useEffect, useState } from 'react'
import { InterfaceRoutes } from '../../interfaces/interfaceRoutes'
import './pioneros-energia.css'
import { getFgPionerosEnergias } from '../../config/services/strapi/pioneros-energia'
import TextSkeleton from '../../components/Skeleton/TextSkeleton'
import { normalizeHeroImages } from '../../helpers/strapiMedia'
import { renderBlocksAsParagraphs } from '../../helpers/renderBlocksAsParagraphs'
import { useSimpleCarousel } from '../../hooks/useSimpleCarousel'
import HeroCarousel from '../../components/hero-carousel/HeroCarousel'

const PionerosEnergia = (_props: InterfaceRoutes) => {
  const [loading, setLoading] = useState(true)
  const [carouselImages, setCarouselImages] = useState<any[]>([])
  const [descripcion, setDescripcion] = useState<any>(null)
  const [detalle, setDetalle] = useState<any>(null)
  const { activeSlide, goToSlide, trackRef, slideRefs } = useSimpleCarousel(carouselImages.length)

  useEffect(() => {
    const load = async () => {
      try {
        const response = await getFgPionerosEnergias()
        const attrs = response?.attributes || response || {}

        setCarouselImages(normalizeHeroImages(attrs?.hero, 'Pioneros de la energia'))
        setDescripcion(attrs?.descripcion || null)
        setDetalle(attrs?.detalle || null)
      } catch (error) {
        console.error('Error cargando Pioneros de la energia:', error)
      } finally {
        setLoading(false)
      }
    }

    load()
  }, [])

  return (
    <div className="pioneros-page">
      <HeroCarousel
        images={carouselImages}
        loading={loading}
        activeSlide={activeSlide}
        goToSlide={goToSlide}
        trackRef={trackRef}
        slideRefs={slideRefs}
        carouselAriaLabel="Carrusel Pioneros de la energia"
        trackAriaLabel="Galeria desplazable de imagenes"
        dotsAriaLabel="Indicadores carrusel"
      />

      <div id="main-content">
        <div className="page-content qs-content">
          <div className="qs-columns">
            <div className="qs-col">
              <h2 className="ph-main-title">Pioneros de la energia</h2>
              {loading ? <TextSkeleton /> : renderBlocksAsParagraphs(descripcion, 'pe-desc')}
            </div>

            <div className="qs-col">
              {loading ? <TextSkeleton /> : renderBlocksAsParagraphs(detalle, 'pe-det')}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PionerosEnergia
